module.exports = __webpack_public_path__ + "static/img/7-1.c60c9d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/7-1.png
// module id = akAu
// module chunks = 0